<template>
    <ls-modal :options="modals.reschedule48" @onModalClose="closeModal('reschedule48')">
        <div slot="header">
            <h3 class="ls-align--center ls-color--green ls-margin--top-none">
                48-hour Reschedule Policy
            </h3>
        </div>

        <div class="grid">
            <div class="grid__col-sm-12">
                <p data-font-size="-1">
                    A service must be canceled 48 hours before it's scheduled date. If the service
                    is canceled within 48 hours of the scheduled service you will be charged the
                    full amount of the service.
                </p>
            </div>
        </div>

        <div slot="button" class="grid">
            <div class="grid__col-12">
                <div>
                    <button
                        slot="button"
                        class="ls-float-right ls-button ls-button--white"
                        type="button"
                        @click="closeModal('reschedule48')"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    </ls-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsModal from '@/components/original-mydot/modals/modal/Modal.vue';

export default {
    components: {
        lsModal,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['modals']),
    },
    methods: {
        ...mapActions({
            closeModal: types.MODAL__CLOSE_MODAL,
        }),
    },
};
</script>

<style lang="scss"></style>
